module.exports = __webpack_public_path__ + "static/media/share-no-bottom-bar.080a03e9.png";